function ez_headerCollapse() {

    var wrapper     = $('.ez_website-wrapper'),
        header      = $('.ez_website-header'),
        workarea    = $('.ez_workarea'),
        headerH     = header.height(),
        headerO     = Math.abs(workarea.offset().top);

    if ( headerO >= headerH ) {
        wrapper.addClass('_scrolled');
    } else {
        wrapper.removeClass('_scrolled');
    }

}